import type { SelectOption } from "../../select/EnhancedSelect";

export { TIME_ENTRY_TYPE_OPTIONS } from "@/features/time-entries/config/constants";

export type { SelectOption };
